import { render, staticRenderFns } from "./CrossSelling.vue?vue&type=template&id=889b3192"
import script from "./CrossSelling.vue?vue&type=script&lang=js"
export * from "./CrossSelling.vue?vue&type=script&lang=js"
import style0 from "./CrossSelling.vue?vue&type=style&index=0&id=889b3192&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports